import React, { useState, useContext, useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
// import AddIcon from '@material-ui/icons/Add';
import { AppContext, LayoutContext } from '../common/contexts';
import { setClassNameInDefns } from '../common/definitionHelper';
import { DASHBOARD_MY_CALENDAR, CALENDAR_TYPE_MONTH, PAGE_TITLE_EMP_MY_CALENDAR } from '../common/constants';
import { logPageView } from '../system/firebase';
import { getFormattedDate, getUserDateFormat } from '../common/dateHelper';
import AfitdPageHead from '../common/elemental/AfitdPageHead';
import AfitdTypography from '../common/elemental/AfitdTypography';
import MonthlyCalendar from './subComponents/MonthlyCalendar';
import WeeklyCalendar from './subComponents/WeeklyCalendar';
import { startOfDay } from 'date-fns';
// import { Tooltip } from '@material-ui/core';
// import InterviewDialog from '../empTalentCenter/subComponents/InterviewDialog';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

const styles = theme => ({
    root: {
        height: '100%',
        background: '#FAFAFC',
    },
    header: {
        height: '128px',
        display: 'flex',
    },
    content: {
        flex: 1,
        overflowY: 'hidden',
        marginTop: 0,
        marginBottom: 0,
        borderRadius: 10,
        backgroundColor: '#fff',
    },
    calendar: {
        width: '100%',
        height: '100%',
        textAlign: 'center',
    },

    headerTitle: {
        marginTop: '38px',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
    },
    headerToday: {
        marginTop: 7,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
    },
    calendarIcon: { color: 'rgba(17, 30, 20, 0.6)', fontSize: 16 },
    todayContainer: {
        marginTop: '1px',
        marginLeft: '9px',
        fontSize: '13px',
        color: 'rgba(17, 30, 20, 0.6)',
    },
    title: {
        fontStyle: 'normal',
        fontWeight: '500',
        fontSize: '26px',
        lineHeight: '30px',
        color: '#111E14',
    },
    confirmedInterviewsContainer: {
        display: 'flex',
        [theme.breakpoints.down('sm')]: { flexDirection: 'column' },
    },
    confirmedInterviewsCount: {
        marginRight: '3px',
        color: '#FC821F',
    },
    confirmedInterviewsText: {
        marginRight: '3px',
    },
    addIcon: { fontSize: 30, padding: 10, borderRadius: 50, backgroundColor: 'rgba(0,0,0,0.03)', margin: '0 0 0 30px', cursor: 'pointer' },
    addIconFlex: { display: 'flex', alignItems: 'center', justifyContent: 'flex-end', /*justifyContent: 'space-between',*/ flex: 1 },
    confirmedInterviewsCountAndText: { display: 'flex' },
});

const getDefns = params => {
    const { props, userDateFormat, confirmedInterviewsCount, selectedDate, /*interviewDialogOpen, setInterviewDialogOpen,*/ setConfirmedInterviewsCount } = params;
    const { classes } = props;

    let defns = {
        toolTip: {
            title: 'Request an interview',
        },
        root: { item: true, container: true, direction: 'column', lg: 12, md: 12, sm: 12, xs: 12 },
        content: { container: true, item: true, spacing: 0 },
        confirmedInterviewsCount: {
            variant: 'body2',
            value: `${confirmedInterviewsCount}`,
        },
        confirmedInterviewsText: {
            variant: 'body2',
            value: `Confirmed interview${confirmedInterviewsCount !== 1 ? 's' : ''} on`,
        },
        confirmedInterviewDateText: {
            variant: 'body2',
            value: getFormattedDate(selectedDate, userDateFormat),
        },
        todayText: {
            variant: 'caption',
            value: getFormattedDate(new Date(), userDateFormat),
            clsBigCaption: true,
        },
        monthlyCalendar: {
            setConfirmedInterviewsCount,
        },
        weeklyCalendar: {
            setConfirmedInterviewsCount,
        },
        // addIcon: { onClick: () => setInterviewDialogOpen(true) },
        // interviewDialog: {
        //     open: interviewDialogOpen,
        //     onClose: () => setInterviewDialogOpen(false),
        // },
    };
    setClassNameInDefns(defns, classes);

    return defns;
};

const MyCalendar = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------
    const appContext = useContext(AppContext);
    const userDateFormat = getUserDateFormat(appContext);
    const context = useContext(LayoutContext);
    const theme = useTheme();
    const smMatches = useMediaQuery(theme.breakpoints.down('sm'));

    //---------------------------------------------------------------------
    // Local states
    //---------------------------------------------------------------------
    const [calendarType, setCalendarType] = useState(CALENDAR_TYPE_MONTH);
    // const [interviewDialogOpen, setInterviewDialogOpen] = useState(false);
    const [confirmedInterviewsCount, setConfirmedInterviewsCount] = useState(0);
    const [selectedDate, setSelectedDate] = useState(startOfDay(new Date()));

    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------
    useEffect(() => {
        logPageView(PAGE_TITLE_EMP_MY_CALENDAR);
    }, []);

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Defns
    //---------------------------------------------------------------------
    const defns = getDefns({ props, userDateFormat, confirmedInterviewsCount, setConfirmedInterviewsCount, selectedDate /*interviewDialogOpen, setInterviewDialogOpen*/ });

    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------
    return (
        <LayoutContext.Provider value={{ ...context, calendarType, setCalendarType, selectedDate, setSelectedDate }}>
            <AfitdPageHead title={PAGE_TITLE_EMP_MY_CALENDAR} />
            <Grid {...defns.root}>
                <Grid {...defns.header}>
                    <div>
                        <div {...defns.headerTitle}>
                            <AfitdTypography {...defns.title}>{DASHBOARD_MY_CALENDAR}</AfitdTypography>
                        </div>
                        <div {...defns.headerToday}>
                            <CalendarTodayIcon {...defns.calendarIcon} />
                            <div {...defns.todayContainer}>
                                <AfitdTypography {...defns.todayText} />
                            </div>
                        </div>
                    </div>
                    <div {...defns.addIconFlex}>
                        {/* <Tooltip {...defns.toolTip}>
                            <AddIcon {...defns.addIcon} />
                        </Tooltip> */}
                        {smMatches ? (
                            <div {...defns.confirmedInterviewsContainer}>
                                <div {...defns.confirmedInterviewsCountAndText}>
                                    <AfitdTypography {...defns.confirmedInterviewsCount} />
                                    <AfitdTypography {...defns.confirmedInterviewsText} />
                                </div>
                                <AfitdTypography {...defns.confirmedInterviewDateText} />
                            </div>
                        ) : (
                            <div {...defns.confirmedInterviewsContainer}>
                                <AfitdTypography {...defns.confirmedInterviewsCount} />
                                <AfitdTypography {...defns.confirmedInterviewsText} />
                                <AfitdTypography {...defns.confirmedInterviewDateText} />
                            </div>
                        )}
                    </div>
                </Grid>
                <Grid {...defns.content}>
                    <div {...defns.calendar}>
                        {calendarType === CALENDAR_TYPE_MONTH && <MonthlyCalendar {...defns.monthlyCalendar} />}
                        {calendarType !== CALENDAR_TYPE_MONTH && <WeeklyCalendar {...defns.weeklyCalendar} />}
                    </div>
                </Grid>
            </Grid>
            {/* {interviewDialogOpen && <InterviewDialog {...defns.interviewDialog} />} */}
        </LayoutContext.Provider>
    );
};

export default withStyles(styles)(MyCalendar);
